







import { Component, Vue } from 'vue-property-decorator';
import client from '../shared/plugins/content';

@Component({
  name: 'product-demos',
  layout: 'default',
  metaInfo: {
    title: 'Product Demos',
  },
})
export default class ProductDemos extends Vue {
  posts: any[] = [];

  mounted() {
    client
      .getEntries({
        content_type: 'helpPosts',
      })
      .then((response: { items: any[] }) => {
        this.posts = response.items;
      });
  }
}
